import { render } from "./CompareAnswer.vue?vue&type=template&id=22cea746&scoped=true"
import script from "./CompareAnswer.vue?vue&type=script&lang=js"
export * from "./CompareAnswer.vue?vue&type=script&lang=js"

import "./CompareAnswer.vue?vue&type=style&index=0&id=22cea746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cea746"]])

export default __exports__